<template>
    <div style="width:100%; height:100%" class="no-select" oncontextmenu="return false;">
      <transition name="fade" mode="out-in">
        <FullscreenLoader key="loader" v-if="loading">{{$t('general.just_a_moment')}}</FullscreenLoader>
        <RtoRenderer v-else-if="currentRtos && Object.keys(currentRtos).length>0" :rto-categories="currentRtos" :action-text="$t('general.continue')" key="rtos" @next="rtoNext()"></RtoRenderer>
        <JourneyPhaseOuttro v-else-if="showOuttro" :outtrocontent="prevOuttro" key="outtro" @complete="outtroComplete()"></JourneyPhaseOuttro>
        <JourneyComplete v-else-if="journeyComplete"></JourneyComplete>
        <MeasureEmpty v-else-if="!journeyplan" key="empty"></MeasureEmpty>
        <JourneyProgressRenderer v-else-if="showJourneyProgress" key="progress" :type="isCurrentMeasureFirstInPhase ? 'phase' : 'measure'"  @complete="progressComplete($event)"></JourneyProgressRenderer>
        <JourneyPhaseIntro v-else-if="currentPhaseIntroShouldDisplay && initiated" key="intro"></JourneyPhaseIntro>
        <MeasureRenderer :journeyplan="journeyplan" v-else-if="initiated" @complete="measureCompleteConfirm($event)" :key="journeyplan.journeyplanid"></MeasureRenderer>
      </transition>
      <NavigationButtons :show="showNavigationButtons" style="z-index: 1;"></NavigationButtons>
      <ConfirmMeasureComplete :show="showConfirmMeasureComplete" @confirm="measureComplete();showConfirmMeasureComplete=false" @cancel="showConfirmMeasureComplete=false"></ConfirmMeasureComplete>
    </div>
</template>

<script>
  import JourneyPhaseIntro from "./JourneyPhaseIntro";
  import MeasureRenderer from "../measure/MeasureRenderer";
  import FullscreenLoader from "../framework/general/FullscreenLoader";
  import JourneyProgressRenderer from "./JourneyProgressRenderer";
  import JourneyComplete from "./JourneyComplete";
  import MeasureEmpty from "../measure/MeasureEmpty";
  import NavigationButtons from "../framework/general/NavigationButtons";
  import applicationEventHub from "../../events/applicationEventHub";
  import JourneyPhaseOuttro from "./JourneyPhaseOuttro";
  import RtoRenderer from "./RtoRenderer";
  import pageVisibilityTracking from "../../mixins/pageVisibilityTracking";
  import ConfirmMeasureComplete from "./ConfirmMeasureComplete";
  export default {
    name: "JourneyRenderer",
    mixins:[pageVisibilityTracking],
    components:{
      JourneyPhaseIntro,MeasureRenderer,FullscreenLoader,JourneyProgressRenderer,JourneyComplete,MeasureEmpty,NavigationButtons,JourneyPhaseOuttro,RtoRenderer,ConfirmMeasureComplete
    },
    computed:{
      isCurrentMeasureFirstInPhase(){
        return this.$store.getters['assessment/isCurrentMeasureFirstInPhase'];
      },
      journeyplan(){
        return this.$store.state.assessment.journeyplan;
      },
      isCurrentPhaseFirstInJourney(){
        return this.$store.getters['assessment/isCurrentPhaseFirstInJourney'];
      },
      currentPhaseIntroDisplayed(){
        return this.$store.state.assessment.phaseIntrosDisplayed[this.journeyplan.journeyphaseid];
      },
      currentPhaseIntroShouldDisplay() {
        return !this.showJourneyProgress && this.isCurrentMeasureFirstInPhase && !this.currentPhaseIntroDisplayed && this.journeyplan.journeyphase.content;
      },
      assessmentmeasure(){
        return this.$store.state.assessment.assessmentmeasure;
      },
      rtos(){
        return this.$store.getters['assessment/rtosByCategory'];
      },
      journeyComplete(){
        return !this.assessmentmeasure && this.$store.getters['assessment/allPhasesComplete'];
      }
    },
    data(){
      return {
        loading:false,
        currentRtos : null,
        showJourneyProgress : false,
        firstMeasureSinceRefresh: true,
        showNavigationButtons : false,
        showOuttro : false,
        prevOuttro : null,
        initiated:false,
        showConfirmMeasureComplete : false,
      }
    },
    mounted(){
       this.bindNavigationButtons();
       this.assessmentmeasureChanged();
       this.$watch('assessmentmeasure',()=>{
         this.assessmentmeasureChanged();
       })
    },
    methods:{
      bindNavigationButtons(){
         applicationEventHub.$on('framework.buttons_show',this.showHideNavigationButtons);
      },
      unbindNavigationButtons(){
        applicationEventHub.$on('framework.buttons_show',this.showHideNavigationButtons);
      },
      showHideNavigationButtons(state){
        this.showNavigationButtons=state;
      },
      assessmentmeasureChanged(){
        if(!this.assessmentmeasure) return;
        this.startAssessmentmeasureIfNotStarted();

        if((this.isCurrentPhaseFirstInJourney && this.isCurrentMeasureFirstInPhase) || (!this.firstMeasureSinceRefresh)){
           this.showJourneyProgress=true;
        }
        this.firstMeasureSinceRefresh=false;

        this.setCurrentOuttro();
        this.initiated=true;
      },
      setCurrentOuttro(){
        if(!this.prevOuttro){
          this.showOuttro=false;
          if(this.journeyplan.journeyphase.outtrocontent){
            this.prevOuttro = JSON.parse(JSON.stringify(this.journeyplan.journeyphase.outtrocontent));
          }
        }else if(this.isCurrentMeasureFirstInPhase && !this.isCurrentPhaseFirstInJourney){
          this.showOuttro=true;
        }else{
          this.showOuttro=false;
        }
      },
      outtroComplete(){
        this.showOuttro=false;
        this.prevOuttro=null;
        this.setCurrentOuttro();
      },
      startAssessmentmeasureIfNotStarted(){
        if(!this.assessmentmeasure.started_at){
          this.$store.dispatch('assessment/currentAssessmentmeasureStarted');
        }
      },
      measureCompleteConfirm(){
          if(this.journeyplan.measure.measure_type==='internal'){
              this.showConfirmMeasureComplete=true;
          }else{
              this.measureComplete();
          }
      },
      measureComplete(){
        this.loading=true;
        this.$store.dispatch('assessment/currentAssessmentmeasureComplete').then(()=>{
          this.determineRtos();
        }).catch((err)=>{
          console.error(err);
          this.determineRtos();
        });
      },
      determineRtos(){
        const rtos=this.filterRtosForAssessmentmeasure();
        if(Object.keys(rtos).length>0){
          this.currentRtos=rtos;
          this.loading=false;
        }else{
          this.$store.dispatch('assessment/loadCurrentMeasure').then(()=>{
            this.loading=false;
          });
        }
      },
      rtoNext(){
        this.currentRtos=null;
        this.loading=true;
        this.$store.dispatch('assessment/loadCurrentMeasure').then(()=>{
          this.loading=false;
        });
      },
      filterRtosForAssessmentmeasure(){
        const filteredCats={};
        for(let id of Object.keys(this.rtos)){
          const cat=this.rtos[id];
          const filtered=cat.rtos.filter((item)=>item.assessmentmeasureid===this.assessmentmeasure.assessmentmeasureid);
          if(filtered.length>0){
            cat.rtos=filtered;
            filteredCats[id]=cat;
          }
        }
        return filteredCats;
      },
      progressComplete(){
        this.showJourneyProgress=false;
      }
    },
    beforeDestroy() {
      this.unbindNavigationButtons();
    }
  }
</script>

<style scoped>
.no-select{
  -webkit-user-select: none; /* webkit (safari, chrome) browsers */
  -moz-user-select: none; /* mozilla browsers */
  -khtml-user-select: none; /* webkit (konqueror) browsers */
  -ms-user-select: none; /* IE10+ */
}
</style>